// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container.layout3[data-v-27a59946]{padding:0;margin:initial}", ""]);
// Exports
module.exports = exports;
